import { render } from "./restore-default-confirmation-modal.vue?vue&type=template&id=67568795"
import script from "./restore-default-confirmation-modal.vue?vue&type=script&lang=js"
export * from "./restore-default-confirmation-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__